import * as Yup from "yup";
import dayjs from "dayjs";

export const advancedValidationSchema = Yup.object({
    // companyName: Yup
    //     .string()
    //     .required("Required"),
})

export const advancedInitialValues = {
    // documentNo: "",
}

export const validationSchema = Yup.object({
    // locationIds: Yup
    //     .array()
    //     .required("Required"),

})

export const initialValues = {
    locationIds: [],
    // createDateFrom: "",
    // createDateTo: "",

    itemName: "",
    itemCode: "",
    categoryName: "",
    brandName: "",
    uomName: "",
}